export default __webpack_public_path__ + "static/media/AdobeStock_447922922.c6d5776f.jpg";